module.exports = __webpack_public_path__ + "img/image_13.13d13cff.png";